import LTR from "@brand-icons/ploom/burger-menu/burger-menu-ltr.svg";

import { iconFactory } from "../iconFactory";

export const BurgerMenuIcon = iconFactory("BurgerMenuIcon", LTR);
